// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.text-container[data-v-205cbde1] {\n\n    display: flex;\n\n    width: 83.333333%;\n\n    flex-direction: column\n}\n.text-container p[data-v-205cbde1] {\n\n    padding-bottom: 1.25rem;\n\n    font-size: 0.875rem;\n\n    line-height: 1.75rem\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
